<ng-container
  *ngIf="{
    carts: (carts$ | async) ?? {
      items: [],
      pagination: { currentPage: 1, numberOfPages: 1 },
    },
    columns: (columns$ | async) ?? [],
    currentCart: currentCart$ | async,
  } as content"
>
  <div class="container">
    <h2>
      <button class="back-button" (click)="goBack()">
        <span class="material-symbols-outlined">arrow_back</span>
      </button>
      {{ 'cart.list.title' | translate }}
    </h2>

    <div class="table-container">
      <p-table showGridlines [value]="content.carts.items ?? []" [columns]="content.columns" [tableStyle]="{ width: '100%' }">
        <ng-template pTemplate="header" let-columns>
          <tr>
            <th *ngFor="let col of columns">
              {{ col.label }}
            </th>
          </tr>
        </ng-template>

        <ng-template pTemplate="body" let-cart>
          <tr>
            <td class="text-wrap">
              {{ cart.code }}
            </td>

            <td cxFrozenColumn>{{ cart.name }}</td>
            <td cxFrozenColumn>{{ cart.updatedAt | date: 'dd/MM/yyyy' }}</td>
            <td cxFrozenColumn>{{ cart.totalEntries }}</td>
            <td cxFrozenColumn>{{ cart.totalPrice }}</td>
            <td cxFrozenColumn>
              @if (cart.code !== content.currentCart?.data?.code) {
                <button (click)="selectCart(cart)">
                  {{ 'cart.list.edit' | translate }}
                  <span class="material-symbols-outlined"> edit_note </span>
                </button>
              }
            </td>
          </tr>
        </ng-template>
      </p-table>
    </div>

    <div class="pagination-container">
      <pagination
        [currentPage]="content.carts.pagination?.currentPage ?? 1"
        [totalPages]="content.carts.pagination?.numberOfPages ?? 1"
        (changePage)="goToPage($event)"
        [updateUrlOnChange]="false"
      ></pagination>
    </div>
  </div>
</ng-container>
